import React, { useState, useRef, useEffect } from 'react';
import cl from './Logo.module.css'
import ContainerLogo from '../../../assets/Logo/ContainerLogo';
import AIG from '../../../assets/Logo/AIG';
import Automoby from '../../../assets/Logo/Automoby';
import Autonomo from '../../../assets/Logo/Autonomo';
import { baseFileURL } from '../../../Api';


const Dropdown = ({auth}) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (company_id) => { 
    auth.refreshCompany(company_id) 
    setIsOpen(false);
  }; 

  return (
      <>

        <div ref={dropdownRef} className={ cl.logoDiv }>

            <div  onClick={toggleDropdown} className={ cl.companyLogo  }>
            
                <div className={ 
                        baseFileURL === "https://finance.automoby.ge" 
                        ? cl.automoby 
                        : baseFileURL === "https://crm.aig.com.ge" || baseFileURL === "https://crmdev.aig.com.ge"  
                        ? cl.AIG 
                        : baseFileURL === "https://crm.autonomo.kz"   
                        ? cl.autonomo 
                        : baseFileURL === "https://i-logistics.net" 
                        ? cl.containers 
                        : "" 
                    } >
                       
                  {
                      baseFileURL === "https://finance.automoby.ge" 
                      ?  <Automoby  /> 
                      : baseFileURL === "https://crm.autonomo.kz"  
                      ?  <Autonomo  /> 
                      : baseFileURL === "https://crm.aig.com.ge" || baseFileURL === "https://crmdev.aig.com.ge"  
                      ?  <AIG  /> 
                      : baseFileURL === "https://i-logistics.net" || baseFileURL === "https://dev.i-logistics.net" 
                      ? <div className={cl.LogoContainer}>
                      <ContainerLogo  />
                      <span>i-Logistics</span>  
                  </div> 
                      : "" 
                  }
                         
                </div>

            </div> 


                { baseFileURL !== "https://crm.autonomo.kz" ? 
                  <>
                      {isOpen && auth.isRole('administrator', 'superadmin') && (
                              <div className={ cl.dropdownContent }>
                                  {auth.companies.map((company, index) => (
                                      <a target='_blank' href={ 
                                        company.company_id === "1" 
                                        ? 'https://finance.automoby.ge/' 
                                        : company.company_id === "2" 
                                        ? 'https://crm.aig.com.ge/' 
                                        : company.company_id === "3" 
                                        ? 'https://i-logistics.net/'
                                        : "" 
                                    } 
                                          className={ 
                                            company.company_id === "1" 
                                            ? '' 
                                            : company.company_id === "2" 
                                            ? '' 
                                            : company.company_id === "3" 
                                            ? cl.containersLogo 
                                            : "" 
                                            } 
                                          key={index} 
                                          onClick={() => handleItemClick(company.company_id)}
                                      >
                                          {company.svgBig}
                                          
                                          { 
                                                company.company_id === "1" 
                                                ? '' 
                                                : company.company_id === "2" 
                                                ? '' 
                                                : company.company_id === "3" 
                                                ? ''
                                                : "" 
                                            } 
                                      </a>
                                  ))}
                              </div> 
                      )}
                  </>
                  : "" 
                }

             

        </div>
 
      </>
  );
};

export default Dropdown;
